/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCheckRecipient} from '../api'

export const useMutationUpdateCheckRecipient = createReactQueryMutationHook('updateCheckRecipient', updateCheckRecipient)
